import {SET_VIEWPORT} from '../actions/action-types';

/* alternative implementation:
function identifyDeviceType({isMobile, hasTouch}) {
    if (isMobile) {
        return 'mobile';
    }
    if (hasTouch) { return 'tablet'; }
    return 'desktop';
}
*/

function identifyDeviceType({isMobile}) {
    return isMobile ? 'mobile' : 'desktop';
}

export default (state = {}, {type, payload}) => {
    switch (type) {
        case SET_VIEWPORT:
            const deviceType = identifyDeviceType(payload);

            return {
                ...state,
                hasTouch: payload.hasTouch,
                isMobile: deviceType === 'mobile',
                isTablet: deviceType === 'tablet',
                isDesktop: deviceType === 'desktop',
                deviceType,
            };
        default:
            return state;
    }
};
